// src/components/Unsubscribe.jsx
import React, { useState } from 'react';
import './Unsubscribe.css';
import config from '../config';

const Unsubscribe = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleUnsubscribe = async (e) => {
        e.preventDefault();
        if (!email) return;

        setLoading(true);
        setMessage('');
        setError('');

        try {
            const response = await fetch(`${config.API_BASE_URL}/api/unsubscribe/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email: email }),
            });

            const data = await response.json();

            if (response.ok) {
                setMessage(data.message);
                setEmail('');
            } else {
                setError(data.message || 'Failed to unsubscribe');
            }
        } catch (error) {
            setError('Network error. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="unsubscribe-container">
            <div className="unsubscribe-card">
                <div className="unsubscribe-icon">📧</div>
                <h2>Unsubscribe from Newsletter</h2>
                <p>Enter your email address to unsubscribe from our newsletter.</p>

                {message && <div className="success-message">{message}</div>}
                {error && <div className="error-message">{error}</div>}

                <form onSubmit={handleUnsubscribe}>
                    <input
                        type="email"
                        placeholder="Your email address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        disabled={loading}
                    />
                    <button type="submit" disabled={loading}>
                        {loading ? 'Processing...' : 'Unsubscribe'}
                    </button>
                </form>

                <p className="back-link">
                    <a href="/">← Back to Home</a>
                </p>
            </div>
        </div>
    );
};

export default Unsubscribe;